export default __webpack_public_path__ + "static/media/pli_scelle.00b33897.svg";